<template>
  <div>
    <div
      class="user-manager__user kt-portlet kt-portlet--height-fluid"
      v-if="!isSalesperson"
    >
      <div
        class="kt-portlet__head kt-portlet__head kt-portlet__head--lg kt-portlet__head--noborder kt-portlet__head--break-sm"
      >
        <div class="kt-portlet__head-label">
          <span class="kt-portlet__head-icon">
            <i class="fal fa-users"></i>
          </span>
          <h3 class="kt-portlet__head-title">
            <span class="heading-6"> LMS Summary Report </span><br />
            <span class="subtitle-1"
              >This section allows to view LMS Summary Report
            </span>
          </h3>
        </div>
        <div class="kt-portlet__head-toolbar">
          <div class="kt-portlet__head-group">
            <v-dialog
              v-model="newUserForm"
              max-width="1200px"
              transition="dialog-bottom-transition"
            >
              <v-card>
                <v-card-text>
                  <v-container class="kt-form">
                    <h4 class="mt-5">
                      {{ editedItem.name }}
                    </h4>
                    <v-col>
                      <lms-summary-report :userId="userId" />
                    </v-col>
                  </v-container>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="blue-grey darken-1" text @click="close"
                    >Close</v-btn
                  >
                </v-card-actions>
              </v-card>
            </v-dialog>
          </div>
        </div>
      </div>

      <div class="kt-portlet__body">
        <div class="kt-widget29">
          <div
            class="kt-widget29__content"
            style="padding: 0 1rem 0 1rem !important"
          >
            <div class="row">
              <div class="col-lg-4"></div>
              <div class="col-lg-4"></div>
              <div class="col-lg-4">
                <v-text-field
                  class="mt-0 pt-1 mr-0 mr-sm-5 w-100"
                  clearable
                  v-model.trim="pagination.search"
                  @change="getUsers"
                  append-icon="fal fa-search"
                  placeholder="Search Name "
                  label="Search"
                  single-line
                  hide-details
                />
              </div>
            </div>
          </div>
        </div>
        <v-data-table
          :headers="headers"
          :items="users"
          :items-per-page="pagination.per_page"
          :server-items-length="pagination.total"
          :search="userSearch"
          @update:page="changePage"
          no-results-text="No results..."
          :loading="isFetching"
          :options.sync="options"
          class="elevation-1"
        >
          <template v-slot:item.groups="{ item }">
            <span>{{ formatGroup(item.groups) }}</span>
            <v-tooltip
              content-class="see-info"
              bottom
              v-if="item.groups.toString().length > 15"
            >
              <template v-slot:activator="{ on, attrs }">
                <span v-bind="attrs" v-on="on" style="color: blue"> more </span>
              </template>
              <template>
                <span v-for="(group, index) in item.groups" :key="group">
                  <span v-if="index != 0">, </span>
                  <span>{{ group }}</span>
                </span>
              </template>
            </v-tooltip>
          </template>
          <template v-slot:item.last_login_at="{ item }">
            <span>{{ item.last_login_at }}</span>
          </template>
          <template v-slot:item.created_at="{ item }">
            <span>{{ item.created_at }}</span>
          </template>
          <template class="user-btn-wrapper" v-slot:item.action="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  text
                  small
                  v-bind="attrs"
                  v-on="on"
                  @click="editItem(item)"
                  color="grey darken-3"
                >
                  <v-icon small>fa fa-eye</v-icon>
                </v-btn>
              </template>
              <span>View Report</span>
            </v-tooltip>
          </template>
        </v-data-table>
      </div>
    </div>

    <div v-else>
      <div class="row">
        <div class="col-lg-12">
          <lms-summary-report :userId="$auth.user().id"></lms-summary-report>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  each as lodashEach,
  head as lodashHead,
  filter as lodashFilter,
  map as lodashMap,
  pick as lodashPick,
  startCase as lodashStartCase,
  toLower as lodashToLower,
  some as _some,
  remove as _remove,
  isEmpty as _isEmpty,
  orderBy as _orderBy,
} from 'lodash-es';
import dayjs from 'dayjs';
import ConfirmDialog from '@/components/dialogs/ConfirmDialog';
import LmsSummaryReport from '../components/client-reports/LmsSummaryReport.vue';

export default {
  name: 'UserBase',
  components: {
    LmsSummaryReport,
    ConfirmDialog,
  },
  data: () => ({
    fromDateMenu: false,
    fromDateVal: null,
    filterLastLoginAt: false,
    filterLastLoginVal: null,
    minDate: '2020-01-05',
    maxDate: '2019-08-30',
    search: '',
    options: {},
    isFetching: false,
    userSearch: '',
    newUserForm: false,
    showPassword: false,
    showConfirmPassword: false,
    dealerList: [],
    roleList: [],
    specificDealerListSource: [],
    specificDealerList: [],
    specificLists: [],
    allSpecificDealerList: [],
    userApprovalDialog: false,
    currentUserInApprovalWindow: '',
    sortBy: 'name',
    sortDesc: true,
    userId: '',
    showConfirmDeletionDialog: false,
    selectedUserId: '',
    headers: [
      {
        text: 'Name',
        align: 'left',
        value: 'name',
        sortable: true,
      },
      {
        text: 'Date Created',
        value: 'created_at',
        align: 'center',
        sortable: true,
      },
      {
        text: 'Actions',
        value: 'action',
        align: 'center',
        width: 250,
        sortable: false,
      },
    ],
    users: [],
    editedIndex: -1,
    editedItem: {
      id: 0,
      name: '',
      email: '',
      phone_number: '',
      dealer_id: '',
      specific_dealer_id: '',
      password: '',
      password_confirmation: '',
      profilePic: '',
      roles: '',
      status: '',
      lmsAccess: false,
      secretShopAccess: false,
    },
    defaultItem: {
      name: '',
      email: '',
      phone_number: '',
      dealer: '',
      specific_dealer: '',
      password: '',
      password_confirmation: '',
      profilePic: '',
      roles: '',
      status: '',
      lmsAccess: false,
      secretShopAccess: false,
    },
    pagination: {
      total: 1,
      per_page: 10,
      current_page: 1,
      search: '',
      sortBy: '',
      sortDesc: false,
      types: ['Active', 'Under Review'],
      picker: null,
      filterLogin: null,
      filterSpecificDealer: [],
    },
  }),

  computed: {
    filterLastLogin() {
      return this.filterLastLoginVal;
    },

    fromDateDisp() {
      return this.fromDateVal;
    },
    formTitle() {
      return 'LMS Summary Report';
    },
    currentUser() {
      return this.$auth.user();
    },
    roles() {
      return this.currentUser.roles;
    },
    isSalesperson() {
      return _some(this.roles, { name: 'salesperson' });
    },
    isAutomotive() {
      return this.currentUser.dealer !== null
        ? this.currentUser.dealer.is_automotive
        : false;
    },
    isSpecificDealerManager() {
      return _some(this.roles, { name: 'specific-dealer-manager' });
    },
    isAdmin() {
      return _some(this.roles, { name: 'super-administrator' });
    },
    isCurrentUserSuperAdmin() {
      return _some(this.$auth.user().roles, { name: 'super-administrator' });
    },
    selectAllDealer() {
      return (
        this.pagination.filterSpecificDealer.length ===
        this.specificLists.length
      );
    },
    selectSomeDealer() {
      return (
        this.pagination.filterSpecificDealer.length > 0 && !this.selectAllDealer
      );
    },
  },

  watch: {
    newUserForm(val) {
      const body = document.body;
      if (val) {
        body.classList.add('dialog-is-open');
        console.log(body.classList);
      } else {
        body.classList.remove('dialog-is-open');
      }
      val || this.close();
    },
    options: {
      handler() {
        this.getUsers();
      },
      deep: true,
    },
  },

  created() {
    this.initialize();
  },

  methods: {
    getSpecificName(val, i) {
      if (val[i].name.length > 7) {
        return val[i].name.substring(0, 15) + '...';
      }
      return val[i].name;
    },
    getSpecific() {
      const dealerId = this.currentUser.dealer['id'];
      const list = _orderBy(this.specificDealerListSource, ['name'], 'asc');
      this.specificLists = list;
    },
    resetForm() {
      this.pagination = {
        total: 1,
        per_page: 10,
        current_page: 1,
        search: '',
        sortBy: '',
        sortDesc: false,
        types: ['Active', 'Inactive'],
        picker: null,
        filterLogin: null,
        filterSpecificDealer: [],
      };
      this.fromDateVal = null;
      this.filterLastLoginVal = null;

      this.getUsers();
    },

    closeConfirmDialog() {
      this.isFetching = false;
      this.showConfirmDeletionDialog = false;
      this.selectedUserId = '';
    },

    searchSpecificDealer(query) {
      const dealerId = this.editedItem.dealer_id;
      this.specificDealerList = lodashFilter(
        this.specificDealerListSource,
        (specificDealer) =>
          specificDealer.dealerId === dealerId &&
          specificDealer.name.indexOf(query) !== 1
      );
    },

    addNewSpecificDealer(newDealer) {
      const dealer = {
        id: newDealer,
        name: newDealer,
      };

      this.specificDealerListSource.push(dealer);
      this.specificDealerList.push(dealer);
      this.editedItem.specific_dealer_id = dealer;
    },
    initialize() {
      this.getUsers();
    },

    getUsers() {
      this.isFetching = true;
      this.pagination.picker = this.fromDateVal;
      this.pagination.filterLogin = this.filterLastLoginVal;
      this.pagination.sortBy =
        this.options.sortBy !== undefined ? this.options.sortBy[0] : '';
      this.pagination.sortDesc =
        this.options.sortDesc !== undefined ? this.options.sortDesc[0] : '';
      this.$store
        .dispatch('users/getUsers', {
          payload: this.pagination,
        })
        .then(({ data }) => {
          this.isFetching = false;
          this.users = [];
          this.pagination.total = data.total;
          this.pagination.current_page = data.current_page;
          this.pagination.per_page = Number(data.per_page);
          lodashEach(data.data, (user) => {
            const lastLoginAt = !_isEmpty(user.last_login_at)
              ? dayjs(user.last_login_at).format('MMM D, YYYY')
              : '';
            const createdAt = !_isEmpty(user.created_at)
              ? dayjs(user.created_at)
              : '';
            this.users.push({
              id: user.id,
              name: user.name,
              email: user.email,
              last_login_at: lastLoginAt,
              created_at: createdAt,
              dealer_id: user.dealer_id,
              specific_dealer_id: user.specific_dealer_id,
              is_active: lodashStartCase(
                lodashToLower(user.status.replace('_', ' '))
              ),
              groups: lodashMap(user.groups, 'name'),
              roles: lodashMap(user.roles, 'id'),
              lmsAccess:
                lodashMap(user.roles, 'name').join(' ').indexOf('lms') !== -1,
              secretShopAccess:
                lodashMap(user.roles, 'name').join(' ').indexOf('shop') !== -1,
              phone_number: user.phone_number,
              password: '',
              // no record or column yet in database
              profilePic: '',
            });
          });
        });
    },

    editItem(item) {
      this.userId = item.id;
      this.editedIndex = this.users.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.editedItem.dealer_id = item.dealer_id;
      if (item.specific_dealer_id) {
        this.editedItem.specific_dealer_id = lodashFilter(
          this.allSpecificDealerList,
          { id: item.specific_dealer_id }
        );
      }
      this.newUserForm = true;
    },
    changePage(page) {
      this.pagination.current_page = page;
      this.getUsers();
    },

    close() {
      this.newUserForm = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },
    save() {
      if (this.editedIndex > -1) {
        Object.assign(this.users[this.editedIndex], this.editedItem);
        if (!this.editedItem.password) {
          delete this.users[this.editedIndex].password;
        }
        const editUserUrl = `/users/${this.users[this.editedIndex].id}`;
        this.$http
          .patch(editUserUrl, this.users[this.editedIndex])
          .then((response) => {
            const { user, specificDealer } = response.data;
            if (specificDealer) {
              this.allSpecificDealerList.push({
                name: specificDealer.name,
                id: specificDealer.id,
              });
            }
            this.users.splice(this.editedIndex, 1, {
              id: user.id,
              name: user.name,
              email: user.email,
              dealer_id: user.dealer_id,
              specific_dealer_id: user.specific_dealer_id,
              is_active: lodashStartCase(
                lodashToLower(user.status.replace('_', ' '))
              ),
              roles: lodashMap(user.roles, 'id'),
              groups: lodashMap(user.groups, 'name'),
              lmsAccess: lodashMap(user.roles, 'name').indexOf('lms') !== -1,
              secretShopAccess:
                lodashMap(user.roles, 'name').join(' ').indexOf('shop') !== -1,
              phone_number: user.phone_number,
              password: '',
              // no record or column yet in database
              profilePic: '',
            });
            this.$notify('success', 'User successfully updated.');
          })
          .catch((errors) => {
            const messages = errors.response.data.errors;
            lodashEach(messages, (value, key) => {
              this.errors.add({
                field: key,
                msg: lodashHead(value),
              });
            });
          });
        this.close();
      } else {
        if (this.isAutomotive) {
          const specificDealer = lodashHead(
            lodashFilter(this.allSpecificDealerList, [
              'id',
              this.currentUser.specific_dealer_id,
            ])
          );
          if (this.currentUser.specific_dealer_id) {
            this.editedItem['specific_dealer_id'] = {
              id: this.currentUser.specific_dealer_id,
              name: specificDealer.name,
            };
          }
        }
        const storeNewUserUrl = '/users/';
        this.$http
          .post(storeNewUserUrl, this.editedItem)
          .then((response) => {
            // eslint-disable-next-line camelcase
            const { user, specificDealer } = response.data;
            if (specificDealer) {
              this.allSpecificDealerList.push({
                name: specificDealer.name,
                id: specificDealer.id,
              });
            }
            this.users.push({
              id: user.id,
              name: user.name,
              email: user.email,
              dealer_id: user.dealer_id,
              specific_dealer_id: user.specific_dealer_id,
              is_active: lodashStartCase(
                lodashToLower(user.status.replace('_', ' '))
              ),
              roles: lodashMap(user.roles, 'id'),
              groups: lodashMap(user.groups, 'name'),
              lmsAccess: lodashMap(user.roles, 'name').indexOf('lms') !== -1,
              secretShopAccess:
                lodashMap(user.roles, 'name').join(' ').indexOf('shop') !== -1,
              phone_number: user.phone_number,
              password: '',
              // no record or column yet in database
              profilePic: '',
            });
            this.$notify('success', 'New user successfully created.');
            this.close();
          })
          .catch((errors) => {
            const messages = errors.response.data.errors;
            lodashEach(messages, (value, key) => {
              this.errors.add({
                field: key,
                msg: lodashHead(value),
              });
            });
          });
      }
    },

    formatGroup(group) {
      if (group) {
        let val = group.toString();

        if (val.length > 15) {
          return val.substring(0, 15) + '...';
        }
        return val;
      }
      return '';
    },
  },
};
</script>
<style lang="stylus" scoped>
.multiselect {
  margin-top: 9px;
}

.v-icon.v-icon {
  font-size: 16px;
}

.user-btn {
  margin: 0px 4px;
}

@media screen and (max-width: 1388px) {
  .user-btn {
    display: block !important;
    margin: 4px auto;
  }
}

@media screen and (max-width: 599px) {
  .user-btn {
    display: inline-block !important;
    margin: 0px 4px;
  }
}
.see-info {
  background: white !important;
  color: black !important;
  border: 1px solid #8a8a8a;
  width: 250px;
}
</style>
